import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ObservationDefinitionDetailsComponent } from './observation-definition-details.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';


@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule],
  declarations: [ObservationDefinitionDetailsComponent],
  exports: [ObservationDefinitionDetailsComponent]
})
export class ObservationDefinitionDetailsModule { }
